import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Default currency symbol - can be overridden
let currencySymbol = "Rs";

export function setCurrencySymbol(symbol) {
  currencySymbol = symbol || "Rs";
}

export function getCurrencySymbol() {
  return currencySymbol;
}

export function formatCurrency(amount, symbol = null) {
  const sym = symbol || currencySymbol;
  const num = parseFloat(amount) || 0;
  return `${sym} ${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatDate(dateString) {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '';
  return new Date(dateString).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function generateWhatsAppLink(phone, message) {
  // Remove non-numeric characters from phone
  const cleanPhone = phone.replace(/\D/g, '');
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${cleanPhone}?text=${encodedMessage}`;
}

export function generateInvoiceMessage(invoice, settings) {
  const businessName = settings?.business_name || 'GaragePro';
  const currency = settings?.currency_symbol || 'Rs';
  return `Hello ${invoice.customer_name},

Thank you for choosing ${businessName}!

Invoice #: ${invoice.invoice_no}
Date: ${formatDate(invoice.date)}
Vehicle: ${invoice.vehicle_number}

Total Amount: ${currency} ${parseFloat(invoice.grand_total).toLocaleString('en-US', { minimumFractionDigits: 2 })}
Payment Status: ${invoice.payment_status.toUpperCase()}

For any queries, please contact us.
Thank you!`;
}

export function getPaymentStatusColor(status) {
  switch (status) {
    case 'paid':
      return 'badge-success';
    case 'pending':
      return 'badge-warning';
    case 'partial':
      return 'badge-info';
    default:
      return 'badge-info';
  }
}

export function truncate(str, length = 30) {
  if (!str) return '';
  return str.length > length ? str.substring(0, length) + '...' : str;
}
